export enum AuthenticationResultTypes
{
	UnknownUser = 1,
	UserLockedOut = 2,
	Successful = 3,
	SessionExpired = 4
}

export enum CustomerAccountTypes
{
	Unknown = 0,
	Individual = 1,
	SoleProprietorship = 2,
	Partnership = 3,
	Corporation = 4,
	Municipality = 5,
	NonProfitOrganization = 6,
	Employee = 7,
	BankOffices = 8,
	OutsideBankOfficer = 9
}

export enum CustomerChangeRequestStates
{
	Created = 1,
	Submitted = 2,
	Modified = 3,
	Cancelled = 4,
	Assigned = 5,
	UnderReview = 6,
	Rejected = 7,
	Processing = 8,
	Completed = 9
}

export enum CustomerChangeRequestTypes
{
	Unknown = 0,
	BankAccountChange = 1,
	NameChange = 2,
	PaymentDateChange = 3,
	AddressChange = 4,
	PhoneChange = 5,
	EmailChange = 6,
	OtherRequest = 7,
	LeaseTransfer = 8
}

export enum PaymentFrequencyTypes
{
	Monthly = 1,
	BiWeekly = 2,
	MonthlyEquivalent = 3,
	Weekly = 4 
}

